module.exports = __webpack_public_path__ + "img/modal-close.379f292d.png";